/**
 * PreludeView React component
 * 
 * @author    Maurizio Tidei, Jens Gruschel
 * @copyright © 2020 contexagon GmbH
 */


import React from 'react';
import {withStyles} from "@material-ui/core";
import PropTypes from 'prop-types';
import {patchServerUrl} from "../../../config";
import {getMediaUrl} from '../../../operations/utils';
import PresentationTitle from "./PresentationTitle";
import MediaPanel from "../../base/MediaPanel";


const screenRatio = 16 / 9;
const screenHeightVW = screenRatio * 100;


/**
 * PreludeView
 *
 * @author Maurizio Tidei, Jens Gruschel
 */
function PreludeView(props) {

    const {classes, screenIndex} = props;
    const topVW = screenIndex ? screenIndex * screenHeightVW : 0;

    const presentationProgram = props.presentationProgram || {};
    const presentationProgramFields = presentationProgram.fields || {};

    const mediaItemList = props.findReferencedObjects(presentationProgramFields['preludeVideo']);
    const mediaItem = mediaItemList[Math.floor(Math.random() * mediaItemList.length)];
    const videoUrl = getMediaUrl(mediaItem);

    console.log("PreludeView", presentationProgramFields['preludeVideo'], mediaItem, videoUrl, props.boxName);

    return <div style={{transform: "translate(0, " + -topVW + "vw)"}}>
        <div className="presentation-screen prelude-screen">
            <div className={classes.logo}>
                <img width="100%" src={patchServerUrl("/images/unikn/unikn-logo-white.png")}/>
            </div>
            <PresentationTitle
                className={classes.titleSection}
                title={presentationProgramFields.title}
                subheading={presentationProgramFields.subheading}
            />
            <div className={classes.upperScreenMargin}>
                <hr className={classes.screenMarginHr}/>
            </div>
            <div className={classes.video}>
                <MediaPanel volume={props.screenIndex == 1 ? 0 : undefined} url={videoUrl} full={true} showControls={false} playOnClick={false} autoplay={true} loop={true} otherFilesAsDownload={false} />
            </div>
            <div className={classes.qrCode}>
                <img width="100%" src={patchServerUrl("/images/unikn/qr-" + (props.boxName ? props.boxName : "kubus1") + ".png")}/>
            </div>
            <div className={classes.badgeOne}>
                <img width="100%" src={patchServerUrl("/images/unikn/download-on-the-app-store-apple.svg")}/>
            </div>
            <div className={classes.badgeTwo}>
                <img width="100%" src={patchServerUrl("/images/unikn/google-play-badge.svg")}/>
            </div>
            <div className="presentation-call-to-action">
                Downloade die KON.SCREEN App und mache dein Smartphone zur Fernbedienung für diesen Screen.
            </div>
            <div className={classes.lowerScreenMargin}>
                <hr className={classes.screenMarginHr}/>
            </div>
        </div>
    </div>;
}

PreludeView.propTypes = {
    screenIndex: PropTypes.number,
    boxName: PropTypes.string,
    presentationProgram: PropTypes.object,
    findReferencedObjects: PropTypes.func.isRequired
};

const styles = theme => ({
    logo: {
        position: "absolute",
        top: "20vw",
        width: "84vw",
        margin: "0 8vw"
    },
    titleSection: {
        display: "none",
        position: "absolute",
        top: "125vw",
        marginLeft: "8vw",
    },
    qrCode: {
        position: "absolute",
        top: "145vw",
        width: "25vw",
        marginLeft: "5vw",
    },
    instructions: {
        position: "absolute",
        top: "145vw",
        width: "25vw",
        marginLeft: "40vw",
    },
    badgeOne: {
        position: "absolute",
        top: "164vw",
        width: "22vw",
        left: "35vw",
    },
    badgeTwo: {
        position: "absolute",
        top: "164vw",
        width: "22vw",
        left: "61vw",
    },
    video: {
        position: "absolute",
        top: "220vw",
        width: "100vw",
    },
    upperScreenMargin: {
        position: "absolute",
        top: "177.77vw",
    },
    lowerScreenMargin: {
        position: "absolute",
        top: "355.54vw",
    },
    screenMarginHr: {
        width:"100vw",
        backgroundColor:"#444444",
        height:"1px",
        border:0,
        margin:0
    }
});

export default withStyles(styles)(PreludeView);
